export default "__VITE_ASSET__BKNFzxvf__"